import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Image from "next/image";
import Tabs from "@mui/material/Tabs";
import Course from "../../assets/course/banner.png";
import style from "../../styles/PublicCourse.module.css";
import SearchIcon from "@mui/icons-material/Search";
import { Chip } from "@mui/material";
import * as constants from "../../Components/constants";
import moment from "moment";
import Link from "next/link";
import { NextSeo } from "next-seo";
import CustomLoader from "../../Components/CustomLoader/CustomLoader";
import { keyword } from "../../Data/CourseKey";
import Head from "next/head";
import Footer from "../../Components/Shared/Footer/Footer";
const BASE_URL = constants.BASE_URL;
import { CircularProgress, styled } from "@mui/material";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";

const AnimatedPlayCircleIcon = styled(PlayCircleIcon)({
  color: "red",
  fontSize: 32,
  transition: "transform 0.3s ease",
  "&:hover": {
    transform: "scale(1.2)",
  },
});

const YOUTUBEAPI = "AIzaSyBhBSJj633h5T_QmNFIqVzURz8VhWsOTuk";

const PublicViewCourse = ({ adsId, data, isLoggedIn }) => {
  const [value, setValue] = React.useState(0);
  const [allCourses, setAllCourses] = React.useState([]);
  const [categories, setCategories] = React.useState([]);

  console.log(allCourses);

  const searchCoursePost = (e) => {
    courseSearch(e.target.value);
  };

  //Getting Course Category
  React.useEffect(() => {
    fetch(`${BASE_URL}/course/categories/`)
      .then((res) => res.json())
      .then((data) => {
        setCategories(data);
      });
  }, []);

  const courseSearch = (text) => {
    fetch(`${BASE_URL}/course/all/?search=${text}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.message) {
          alert([{ data: data.message }]);
        } else {
          data.length &&
            data.sort((a, b) => {
              return new Date(b.created_date) - new Date(a.created_date);
            });
          setAllCourses(data.reverse());
        }
      });
  };

  //getting all courses data
  React.useEffect(() => {
    courseSearch("");
  }, []);

  //Image and video toggle
  const [playingIndex, setPlayingIndex] = React.useState(null);
  const [vLoading, setVLoading] = React.useState([]);

  const handlePlay = (index) => {
    setVLoading((prev) => {
      const newLoading = [...prev];
      newLoading[index] = true;
      return newLoading;
    });

    setTimeout(() => {
      setPlayingIndex(index);
      setVLoading((prev) => {
        const newLoading = [...prev];
        newLoading[index] = false;
        return newLoading;
      });
    }, 2000);
  };

  const isPlaying = (index) => playingIndex === index;

  if (!allCourses) return <p>No profile data</p>;

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Head>
        <meta name="keywords" content={keyword} />
      </Head>
      <NextSeo
        title="Research Rider | Explore All Courses"
        description="Choose from various online video courses with new additions 
              published every month."
        canonical="https://www.researchrider.com/course"
        openGraph={{
          url: "https://www.researchrider.com/course",
          title: "Research Rider | Explore All Courses",
          description:
            "Choose from various online video courses with new additions published every month.",
          siteName: "Research Rider",
        }}
      />

      {allCourses.length !== 0 ? (
        <>
          {/*----- Banner Section----- */}
          <Row
            className={
              isLoggedIn
                ? `${style.bg_color} text-white justify-content-center  mt-5 py-5`
                : `${style.row_box} ${style.bg_color}  text-white`
            }
          >
            <Col
              md={11}
              className="d-flex justify-content-center align-items-center flex-wrap-reverse"
            >
              <Col md={6} className="mb-3 p-2">
                <h1 className="fw-bold">
                  Learn new skills online with top educators
                </h1>
                <span>
                  Choose from various online video courses with new additions{" "}
                  published every month.
                </span>

                <div className={style.search}>
                  <input
                    type="text"
                    onKeyUp={searchCoursePost}
                    className={style.searchTerm}
                    placeholder="What are you looking for?"
                  />
                  <button type="submit" className={style.searchButton}>
                    <SearchIcon />
                  </button>
                </div>
              </Col>
              <Col md={6} className="text-center">
                <Image
                  priority
                  width={460}
                  height={250}
                  src={Course}
                  alt="course banner"
                />
              </Col>
            </Col>
          </Row>

          <Row className="my-2">
            <Col>
              <Tabs
                onChange={handleChange}
                value={value}
                variant="scrollable"
                sx={{
                  borderBottom: 2,
                  borderTop: 2,
                  borderColor: "divider",
                  display: "flex",
                  alignItems: "center",
                  p: 2,
                }}
              >
                {categories.map((course, idx) => (
                  <Chip
                    className="mx-1"
                    key={idx}
                    label={course.name}
                    variant="outlined"
                  />
                ))}
              </Tabs>
            </Col>
          </Row>

          <Container>
            {/*----- Course View Section----- */}
            <Row xs={1} sm={2} md={3} xl={4} xxl={5} className="g-2 my-3">
              {allCourses.map((course, idx) => (
                <Col key={idx}>
                  <Card className={`${style.card} rounded`}>
                    <div style={{ position: "relative" }}>
                      <Link href={`/course/${course.id}`}>
                        <Card.Img
                          className={`${style.cardImg} border`}
                          variant="top"
                          src={course.cover_pic}
                          alt={course.name}
                        />
                      </Link>

                      {!isPlaying(idx) &&
                        !course.payment_procedure.startsWith("N/A") && (
                          <Link href={`/course/${course.id}`}>
                            <AnimatedPlayCircleIcon
                              sx={{
                                position: "absolute",
                                top: "4%",
                                left: "86%",
                              }}
                              onClick={() => handlePlay(idx)}
                            />
                          </Link>
                        )}
                    </div>

                    <Link href={`/course/${course.id}`}>
                      <Card.Body>
                        <h2 className={`${style.courseName} text-center`}>
                          {course.name}
                        </h2>

                        <Card.Text className="pt-1">
                          <div className="mx-4 text-danger fw-bold pb-1">
                            &nbsp;
                            {course.course_enroll_start_date.startsWith(
                              "2000-01-01"
                            )
                              ? "Recorded Class"
                              : "Live Class"}
                          </div>
                          <span className={style.video_icon}>
                            <span className={style.circle_outer}></span>
                            <span className={style.circle_inner}></span>
                          </span>
                          {!course.course_enroll_start_date.startsWith(
                            "2000-01-01"
                          ) ? (
                            <>
                              <small className={`${style.date}`}>
                                Enrollemt End:{" "}
                                {moment(course.course_enroll_end_date).format(
                                  "ll"
                                )}
                              </small>

                              <small className={`${style.date}`}>
                                Course Start: &nbsp;
                                {moment(course.start_date).format("ll")}
                              </small>
                            </>
                          ) : (
                            <span
                              dangerouslySetInnerHTML={{
                                __html: `${course.course_outcome.slice(0, 55)}${
                                  course.course_outcome.length > 55 ? "..." : ""
                                }`,
                              }}
                            />
                          )}
                        </Card.Text>
                      </Card.Body>
                    </Link>
                    <Link href={`/course/${course.id}`}>
                      <Card.Footer className="d-flex justify-content-around align-items-center">
                        <span className={style.enroll}>
                          {course.enrollment_fee} BDT
                        </span>
                        <span className={style.enroll}>Enroll Now</span>
                      </Card.Footer>
                    </Link>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
          <Footer />
        </>
      ) : (
        <CustomLoader />
      )}
    </>
  );
};

export default PublicViewCourse;

export async function getServerSideProps() {
  const res = await fetch(`https://researchrider.xyz/course/all/`, {
    headers: {
      Accept: "application/json, text/plain, */*",
      "User-Agent": "*",
    },
  });
  const data = await res.json();
  return {
    props: {
      data,
    },
  };
}
